import { render } from "./AccessDonants.html?vue&type=template&id=1bc0da5a&external"
import script from "./AccessDonants.vue?vue&type=script&lang=js"
export * from "./AccessDonants.vue?vue&type=script&lang=js"

import "./AccessDonants.vue?vue&type=style&index=0&id=1bc0da5a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__